const cookiesStorageManager = {
  setSessionCookies: (name, value, path = '/') => {
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; path=${path}`;
  },
  setPersistentCookie: (name, value, days = 7, path = '/') => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to ms
    const expires = date.toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=${path}`;
  },
  getCookies: (name) => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, val] = cookie.split('=');
      if (decodeURIComponent(key) === name) {
        return decodeURIComponent(val);
      }
    }
    return null;
  },

  removeCookie: (name, path = '/') => {
    document.cookie = `${encodeURIComponent(
      name
    )}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  },
};

export default cookiesStorageManager;
